import { IconBrandApple, IconBrandGoogle } from '@tabler/icons-react-native'
import { Platform } from 'react-native'

import { Button, ButtonIcon, HStack, Text } from '@/components'
import { useAuth } from '@/hooks'
import { COLOR_BLACK } from '@/lib'

export const SocialButtons = () => {
  const { isSigningIn, signInWithApple, signInWithGoogle } = useAuth()

  return (
    <>
      <HStack
        accessibilityElementsHidden
        aria-hidden
        className='items-center justify-center gap-1'
        importantForAccessibility='no'
      >
        <HStack className='w-4 border-[0.5px] border-white' />
        <Text className='text-center text-sm text-white'>or</Text>
        <HStack className='w-4 border-[0.5px] border-white' />
      </HStack>
      <HStack className='items-center justify-center gap-8'>
        <Button
          accessibilityLabel='Sign in with Google'
          className='h-10 w-10 items-center justify-center rounded-full bg-white px-0'
          isDisabled={isSigningIn}
          onPress={signInWithGoogle}
          size='xl'
          testID='SocialButtons.googleButton'
        >
          <ButtonIcon
            aria-hidden
            as={IconBrandGoogle}
            className='h-7 w-7'
            fill={COLOR_BLACK}
          />
        </Button>
        {Platform.OS === 'ios' ? (
          <Button
            accessibilityLabel='Sign in with Apple'
            className='h-10 w-10 items-center justify-center rounded-full bg-white px-0'
            isDisabled={isSigningIn}
            onPress={signInWithApple}
            size='xl'
            testID='SocialButtons.appleButton'
          >
            <ButtonIcon
              aria-hidden
              as={IconBrandApple}
              className='h-7 w-7'
              fill={COLOR_BLACK}
            />
          </Button>
        ) : null}
      </HStack>
    </>
  )
}
